import React, { ReactElement } from 'react';
import { Column, Grid } from 'lmc-ui-library';
import Template from '../../Template/Template';
import ProgressContainer from 'screens/BrokerPortal/screens/Registration/containers/ProgressContainer';

type Props = {
  children: ReactElement;
};

const RegistrationFormTemplate: React.FC<Props> = ({ children }) => {
  return (
    <Template>
      <>
        <ProgressContainer />
        <Grid cols={12}>
          <Column lg={12} md={12} sm={12} xs={12}>
            {children}
          </Column>
        </Grid>
      </>
    </Template>
  );
};

export default RegistrationFormTemplate;
